import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1e606020")

_pushScopeId("data-v-1e606020")
const _hoisted_1 = { class: "LTLInvoice" }
const _hoisted_2 = { class: "LTLInvoice__container" }
const _hoisted_3 = { class: "LTLInvoice__point" }
const _hoisted_4 = { class: "LTLInvoice__scrollable" }
const _hoisted_5 = { class: "scrollable__container scroll ltl" }
const _hoisted_6 = {
  key: 0,
  class: "container__actions"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_order_point = _resolveComponent("order-point")!
  const _component_completed_cargo = _resolveComponent("completed-cargo")!
  const _component_completed_delivery = _resolveComponent("completed-delivery")!
  const _component_completed_services = _resolveComponent("completed-services")!
  const _component_icon_settings_add = _resolveComponent("icon-settings-add")!
  const _component_icon_edit = _resolveComponent("icon-edit")!
  const _component_icon_trash = _resolveComponent("icon-trash")!
  const _component_new_ltl_receiver_additional_services = _resolveComponent("new-ltl-receiver-additional-services")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_order_point, {
          isLTL: _ctx.isLTL,
          isFTL: _ctx.isFTL,
          title: "Получатель",
          blocked: true,
          point: _ctx.invoice.receiver
        }, null, 8, ["isLTL", "isFTL", "point"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_completed_cargo, {
            cargo: _ctx.invoice.cargo
          }, null, 8, ["cargo"]),
          _createVNode(_component_completed_delivery, {
            delivery: _ctx.invoice.delivery
          }, null, 8, ["delivery"]),
          (_ctx.isCanShowAdditionalServices)
            ? (_openBlock(), _createBlock(_component_completed_services, {
                key: 0,
                "additional-services": _ctx.invoice.additional_services,
                "additional-services-billing": _ctx.additionalServices,
                onReset: _ctx.emitResetAdditionalServices
              }, null, 8, ["additional-services", "additional-services-billing", "onReset"]))
            : _createCommentVNode("", true)
        ])
      ]),
      (!_ctx.blocked)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode(_component_icon_settings_add, {
              class: "actions__action",
              onClick: _ctx.openAdditionalServices
            }, null, 8, ["onClick"]),
            _createVNode(_component_icon_edit, {
              class: "actions__action",
              onClick: _ctx.emitStartUpdate
            }, null, 8, ["onClick"]),
            _createVNode(_component_icon_trash, {
              class: "actions__action",
              onClick: _ctx.emitDeleteInvoice
            }, null, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.state.isAdditionalServicesOpened && !_ctx.blocked)
      ? (_openBlock(), _createBlock(_component_new_ltl_receiver_additional_services, {
          key: 0,
          "initial-values": _ctx.invoice.additional_services,
          "additional-services": _ctx.additionalServices,
          "is-bosch": _ctx.isBosch,
          onContinue: _ctx.emitAddAdditionalServices,
          onClose: _ctx.closeAdditionalServices
        }, null, 8, ["initial-values", "additional-services", "is-bosch", "onContinue", "onClose"]))
      : _createCommentVNode("", true)
  ]))
})